module.exports = __webpack_public_path__ + "static/img/s-icon-1.5e26bba.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/s-icon-1.png
// module id = kNPH
// module chunks = 0